import { Injectable } from '@angular/core';
import { TabURLs } from './navbar-top/navbar-top.types';
import { Location } from '@angular/common';
import {
  NX23NavbarTab,
  NX23Link,
  NX23NavbarDropdown,
} from '../../types/content-types';

@Injectable()
export class ActiveTabService {
  constructor(private location: Location) {}

  // PROPERTIES
  /**
   * Currently active tab
   */
  public activeTab!: NX23NavbarTab;
  /**
   * Active tab's signin button
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public get signInButton() {
    return this.activeTab.fields.signinButton.fields;
  }

  // METHODS
  /**
   * Gets and stores the current active tab (/personas, /comercios, etc) from the navbar
   * @param tabs The tabs from the navbar
   */
  public updateActiveTab(tabs: NX23NavbarTab[]): void {
    const path = this.location.path();
    // Active tab URL
    const tabURL = this.getTabURLs(tabs)[path];

    this.activeTab = tabs.find(tab => tab.fields.url === tabURL) ?? tabs[0];
  }

  // PRIVATE METHODS
  /**
   * Generates and object relating each URL to its tab
   * @param tabs The tabs from the navbar
   * @returns An object with the URLs of each tab and its base URL
   */
  private getTabURLs(tabs: NX23NavbarTab[]): TabURLs {
    let tabURLs: TabURLs = {};

    tabs.forEach(({ fields }) => {
      const tab = fields.url;
      const urlList = this.getURLsFromLink(fields.tabContent);

      // Add each url to the object
      urlList.forEach(url => (tabURLs[url] = tab));
      // Also add the base url for the tab
      tabURLs[tab] = tab;
    });

    return tabURLs;
  }

  /**
   * Gets all the URLs from a list of links or dropdowns
   * @param links List of links or dropdowns to get the URLs from
   * @returns A list of URLs
   */
  private getURLsFromLink(links: (NX23Link | NX23NavbarDropdown)[]): string[] {
    const URLs: string[] = [];

    links.forEach(link => {
      if (this.isNavbarDropdown(link))
        URLs.push(...this.getURLsFromLink(link.fields.dropdownContent));
      else URLs.push(link.fields.url);
    });

    return URLs;
  }

  /**
   * Checks if an element is a dropdown
   * @param el Element to check
   * @returns `true` if the element is a dropdown, `false` otherwise
   */
  private isNavbarDropdown(
    el: NX23Link | NX23NavbarDropdown,
  ): el is NX23NavbarDropdown {
    return el.sys.contentType.sys.id === 'nx23NavbarDropdown';
  }
}
